declare let __BUILD_VERSION__: string;

export function cacheBust() {
  window.addEventListener("pageshow", (event) => {
    if (event.persisted) {
      fetch("/assets/JSON/version.json")
        .then((r) => r.json())
        .then((v) => {
          if (v.version !== __BUILD_VERSION__) {
            location.reload();
          }
        });
    }
  });
}
